export default __webpack_public_path__ + "static/media/sd-download.eb3c63b3.svg";